<div class="sun-dialog-backdrop">
	<div class="sun-dialog">
		<div class="content-wrapper">
			<div class="top"><i (click)="callClose()" class="fa-light fa-times fa-xl"></i></div>

			<div class="content">
				<table>
					<tr>
						<td rowspan="2" class="header center">Transmittance</td>
						<td class="header">Filter Category</td>
						<td colspan="2" class="header">Description and Use</td>
						<td rowspan="2" class="header">UV protection rate (280-380nm)</td>
						<td class="blank"></td>
						<td class="header">Additional requirements</td>
					</tr>
					<tr>
						<td class="header">EN ISO 12312-1</td>
						<td class="header">Description</td>
						<td class="header">Use</td>
						<td class="blank"></td>
						<td class="header">ANSI Z80.3 Standard</td>
					</tr>
					<tr>
						<td class="center">3%-8%</td>
						<td class="center">4</td>
						<td>Very dark special purpose sunglasses, very high sunglare reduction</td>
						<td>Very high protection against extreme sunglare, e.g. at sea, over snowfields, on high mountains, or in desert. Not suitable for road use and driving</td>
						<td rowspan="5">100% as defined by EN ISO 12312-1</td>
						<td class="blank"></td>
						<td>Special use</td>
					</tr>
					<tr>
						<td class="center">8%-18%</td>
						<td class="center">3</td>
						<td rowspan="2">General purpose sunglasses</td>
						<td>High protection against sunglare</td>
						<td class="blank"></td>
						<td rowspan="2">General use</td>
					</tr>
					<tr>
						<td class="center">18%-43%</td>
						<td class="center">2</td>
						<td>Good protection against sunglare</td>
						<td class="blank"></td>
					</tr>
					<tr>
						<td class="center">43%-80%</td>
						<td class="center">1</td>
						<td rowspan="2">Light tint sunglasses</td>
						<td>Limited protection against sunglare</td>
						<td class="blank"></td>
						<td rowspan="2">Cosmetic use</td>
					</tr>
					<tr>
						<td class="center">80%-100%</td>
						<td class="center">0</td>
						<td>Very limited reduction of sunglare</td>
						<td class="blank"></td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</div>